import React from "react";
import { useDispatch } from "react-redux";
import YouTube from "react-youtube";
import { initiateCountDown } from "../../../redux/reducers/videoReducer";

const opts = {
  height: "280px",
  width: "580px",
  playerVars: {
    autoplay: 0,
  },
};
const ContentType3 = ({ item }) => {
  const videoId = item.videoLink.split("/");
  const dispatch = useDispatch();
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <YouTube
        videoId={videoId[4]}
        opts={opts}
        onPlay={() => dispatch(initiateCountDown(true))}
        onReady={(e) => e.target.pauseVideo()}
      />
    </div>
  );
};

export default ContentType3;
